<template>
  <div v-if="!isSubAccount" class="sub-account-management">
    <listNav></listNav>
    <div class="sub-account-management-content">
      <SubAccountSidebar></SubAccountSidebar>
      <SubAccountDetail class="sub-account-content-container"></SubAccountDetail>
    </div>
  </div>
</template>
<script>
import listNav from '@components/list/listNav.vue'
import SubAccountSidebar from '@components/sidebars/SubAccountSidebar.vue'
import SubAccountDetail from '@views/SubAccountDetail.vue'
import compareVipRight from '@components/common/compareVipRight.js'

export default {
  name: 'SubAccountManagement',
  mixins: [compareVipRight],
  data() {
    return {}
  },
  computed: {
    currentPath() {
      return this.$route.path
    },
    isSubAccount() {
      return this.$store.state.common.isSubAccount == 1
    }
  },
  methods: {},
  mounted() {
    this.$store.dispatch('common/login').then(() => {
      this.$store.dispatch('manage/getSpace')
      this.getVipInfo()
    })
  },
  components: {
    listNav,
    SubAccountSidebar,
    SubAccountDetail
  }
}
</script>

<style lang="scss" scoped>
.sub-account-management {
  padding-top: 8px;
  .sub-account-management-content {
    display: flex;
    .sub-account-content-container {
      width: calc(100% - 225px);
    }
  }
}
</style>
